import { useEffect } from "react";
import type { Settings } from "./settings";

/** Mirrors synced settings onto <html data-*> so the stylesheet can react (theme, plainColors, reducedMotion). */
export function useApplySettings(s: Settings): void {
  useEffect(() => {
    const el = document.documentElement;
    if (s.theme && s.theme !== "system") el.dataset.theme = s.theme;
    else delete el.dataset.theme;
    el.dataset.plainColors = s.a11y.plainColors ? "true" : "false";
    el.dataset.widgetLines = s.a11y.widgetLines ? "true" : "false";
    el.dataset.reducedMotion = s.a11y.reducedMotion ? "true" : "false";
    el.dataset.muteBadges = s.a11y.muteBadges ? "true" : "false";
  }, [s.theme, s.a11y.plainColors, s.a11y.reducedMotion, s.a11y.muteBadges, s.a11y.widgetLines]);
}
